"use client";

import { useRouter } from "next/navigation";

/**
 * BackButton — 서브페이지 마스트헤드의 "‹ Back".
 *   히스토리가 있으면 뒤로, 없으면(딥링크로 바로 진입) 홈으로 보낸다.
 */
export function BackButton() {
  const router = useRouter();

  function goBack() {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
    } else {
      router.push("/");
    }
  }

  return (
    <button
      type="button"
      onClick={goBack}
      className="-ml-1 inline-flex items-center gap-1 text-sm font-semibold text-white/90 transition-colors hover:text-white"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M15 18l-6-6 6-6" />
      </svg>
      Back
    </button>
  );
}
